"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CommonModels_1 = require("./CommonModels");
var InventorySearchFilter = /** @class */ (function (_super) {
    __extends(InventorySearchFilter, _super);
    function InventorySearchFilter(json) {
        var _this = _super.call(this, json) || this;
        _this.searchQuery = '';
        _this.sku = json.sku;
        _this.searchQuery = json.searchQuery;
        _this.selectedSupplierId = json.selectedSupplierId;
        _this.selectedCategoryId = json.selectedCategoryId;
        _this.selectedSupplierIds = json.selectedSupplierIds;
        _this.selectedCategoryIds = json.selectedCategoryIds;
        _this.locationIds = json.locationIds;
        _this.productIds = json.productIds;
        _this.hideEmptyQuantities = json.hideEmptyQuantities;
        _this.lowStock = json.lowStock;
        return _this;
    }
    return InventorySearchFilter;
}(CommonModels_1.Pagination));
exports.InventorySearchFilter = InventorySearchFilter;
var InventoryFilter = /** @class */ (function () {
    function InventoryFilter(filter) {
        if (filter.productIds)
            this.setProductIds(filter.productIds);
        if (filter.categoryIds)
            this.setCategoryIds(filter.categoryIds);
        if (filter.supplierIds)
            this.setSupplierIds(filter.supplierIds);
        if (filter.isInStock)
            this.setIsInStock(filter.isInStock);
        if (filter.startDate)
            this.setStartDate(filter.startDate);
        if (filter.endDate)
            this.setEndDate(filter.endDate);
        if (filter.wooCommerce)
            this.setWooCommerce(filter.wooCommerce);
        if (filter.onlyNewProducts)
            this.setOnlyNewProducts(filter.onlyNewProducts);
    }
    InventoryFilter.prototype.setProductIds = function (productIds) { this.productIds = productIds; };
    InventoryFilter.prototype.setCategoryIds = function (categoryIds) { this.categoryIds = categoryIds; };
    InventoryFilter.prototype.setSupplierIds = function (supplierIds) { this.supplierIds = supplierIds; };
    InventoryFilter.prototype.setIsInStock = function (isInStock) { this.isInStock = isInStock; };
    InventoryFilter.prototype.setStartDate = function (startDate) { this.startDate = startDate; };
    InventoryFilter.prototype.setEndDate = function (endDate) { this.endDate = endDate; };
    InventoryFilter.prototype.setWooCommerce = function (wooCommerce) { this.wooCommerce = wooCommerce; };
    InventoryFilter.prototype.setOnlyNewProducts = function (includeNewProducts) { this.onlyNewProducts = includeNewProducts; };
    Object.defineProperty(InventoryFilter.prototype, "queryString", {
        get: function () {
            var queryString = '';
            if (this.productIds) {
                queryString += "&productIds=" + JSON.stringify(this.productIds);
            }
            if (this.categoryIds) {
                queryString += "&categoryIds=" + JSON.stringify(this.categoryIds);
            }
            if (this.supplierIds) {
                queryString += "&supplierIds=" + JSON.stringify(this.supplierIds);
            }
            if (this.startDate) {
                queryString += "&startDate=" + this.startDate.toISOString();
            }
            if (this.endDate) {
                queryString += "&endDate=" + this.endDate.toISOString();
            }
            if (this.isInStock) {
                queryString += "&isInStock=" + this.isInStock;
            }
            if (this.onlyNewProducts) {
                queryString += "&onlyNewProducts=" + this.onlyNewProducts;
            }
            return queryString;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], InventoryFilter.prototype, "productIds", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryFilter.prototype, "categoryIds", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryFilter.prototype, "supplierIds", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryFilter.prototype, "startDate", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryFilter.prototype, "endDate", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryFilter.prototype, "isInStock", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryFilter.prototype, "wooCommerce", void 0);
    __decorate([
        mobx_1.observable
    ], InventoryFilter.prototype, "onlyNewProducts", void 0);
    __decorate([
        mobx_1.action
    ], InventoryFilter.prototype, "setProductIds", null);
    __decorate([
        mobx_1.action
    ], InventoryFilter.prototype, "setCategoryIds", null);
    __decorate([
        mobx_1.action
    ], InventoryFilter.prototype, "setSupplierIds", null);
    __decorate([
        mobx_1.action
    ], InventoryFilter.prototype, "setIsInStock", null);
    __decorate([
        mobx_1.action
    ], InventoryFilter.prototype, "setStartDate", null);
    __decorate([
        mobx_1.action
    ], InventoryFilter.prototype, "setEndDate", null);
    __decorate([
        mobx_1.action
    ], InventoryFilter.prototype, "setWooCommerce", null);
    __decorate([
        mobx_1.action
    ], InventoryFilter.prototype, "setOnlyNewProducts", null);
    return InventoryFilter;
}());
exports.InventoryFilter = InventoryFilter;
//# sourceMappingURL=Inventory.js.map